import { StaticImage } from "gatsby-plugin-image"
import { useEffect, useRef } from "react"
import Flickity from "react-flickity-component"

import useWindowDimensions from "../../utils/useWindowDimensions"
import {
  clientLogosContainer,
  flipHorizontal,
  whiteShadow,
} from "./logo-strip.module.css"
import logo1 from "../../images/client-logos/latest/1.png"
import logo2 from "../../images/client-logos/latest/2.png"
import logo3 from "../../images/client-logos/latest/3.png"
import logo4 from "../../images/client-logos/latest/4.png"
import logo5 from "../../images/client-logos/latest/5.png"
import logo6 from "../../images/client-logos/latest/6.png"
import logo7 from "../../images/client-logos/latest/7.png"
import logo8 from "../../images/client-logos/latest/8.png"
import logo9 from "../../images/client-logos/latest/9.png"
import logo10 from "../../images/client-logos/latest/10.png"
import logo11 from "../../images/client-logos/latest/11.png"
import logo12 from "../../images/client-logos/latest/12.png"
import logo13 from "../../images/client-logos/latest/13.png"
import logo14 from "../../images/client-logos/latest/14.png"
import logo15 from "../../images/client-logos/latest/15.png"
import logo16 from "../../images/client-logos/latest/16.png"
import logo17 from "../../images/client-logos/latest/17.png"
import logo18 from "../../images/client-logos/latest/18.png"
import logo19 from "../../images/client-logos/latest/19.png"
import logo20 from "../../images/client-logos/latest/20.png"
import logo21 from "../../images/client-logos/latest/21.png"
import logo22 from "../../images/client-logos/latest/22.png"
import logo23 from "../../images/client-logos/latest/23.png"
import logo24 from "../../images/client-logos/latest/24.png"
import logo25 from "../../images/client-logos/latest/25.png"
import logo26 from "../../images/client-logos/latest/26.png"
import logo27 from "../../images/client-logos/latest/27.png"
import logo28 from "../../images/client-logos/latest/28.png"
import logo29 from "../../images/client-logos/latest/29.png"
import logo30 from "../../images/client-logos/latest/30.png"
import logo31 from "../../images/client-logos/latest/31.png"
import logo32 from "../../images/client-logos/latest/32.png"
import logo33 from "../../images/client-logos/latest/33.png"

const flickityOptions = {
  autoPlay: false,
  wrapAround: true,
  selectedAttraction: 0.01,
  friction: 0.2,
  cellAlign: "left",
  contain: true,
  pageDots: false,
  prevNextButtons: false,
  pauseAutoPlayOnHover: false,
}

export default function LogoStrip(props: {
  slider?: boolean
  fullWidth?: boolean
  isSingleLine?: boolean
}) {
  const { fullWidth, isSingleLine = false } = props
  const { width } = useWindowDimensions()
  const isMobileUp = width >= 1080
  const containerWidth = isMobileUp ? "1080px" : "100%"
  const sectionRef = useRef<HTMLElement>(null)
  const flickityRef1 = useRef<any>(null)
  const flickityRef2 = useRef<any>(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          flickityRef1.current?.playPlayer()
          flickityRef2.current?.playPlayer()
          observer.disconnect()
        }
      },
      { threshold: 0.1 }
    )
    if (sectionRef.current) observer.observe(sectionRef.current)
    return () => observer.disconnect()
  }, [])
  const padding = fullWidth ? "" : "py-16"
  const clientLogos = [
    logo1,
    logo2,
    logo3,
    logo4,
    logo5,
    logo6,
    logo7,
    logo8,
    logo9,
    logo10,
    logo11,
    logo12,
    logo13,
    logo14,
    logo15,
    logo16,
    logo17,
    logo18,
    logo19,
    logo20,
    logo21,
    logo22,
    logo23,
    logo24,
    logo25,
    logo26,
    logo27,
    logo28,
    logo29,
    logo30,
    logo31,
    logo32,
    logo33,
  ]

  const half = Math.ceil(clientLogos.length / 2)
  const slider1 = clientLogos.slice(0, half)
  const slider2 = clientLogos.slice(half)

  return (
    <section ref={sectionRef} className={`${padding}`}>
      <div className="mx-auto" style={{ width: containerWidth }}>
        <div
          className={`${clientLogosContainer} rounded-xl relative opacity-80`}
        >
          <div
            className={`${whiteShadow} absolute left-0 top-0 w-20 bottom-0 z-10`}
          />
          <div
            className={`${whiteShadow} ${flipHorizontal} absolute right-0 top-0 w-20 bottom-0 z-10`}
          />
          <Flickity
            className="carousel"
            elementType="div"
            options={flickityOptions}
            flickityRef={c => { flickityRef1.current = c }}
            disableImagesLoaded={false}
            reloadOnUpdate
            static
          >
            {slider1?.map((logo, idx) => (
              <img
                key={`logo-${idx}`}
                src={logo}
                alt={`Client Logo ${idx + 1}`}
                className="w-24 h-24 object-contain mx-6"
                width="96"
                height="96"
                loading="lazy"
              />
            ))}
          </Flickity>
          {!isSingleLine && (
            <Flickity
              className="carousel mt-4 md:mt-10"
              elementType="div"
              options={flickityOptions}
              flickityRef={c => { flickityRef2.current = c }}
              disableImagesLoaded={false}
              reloadOnUpdate
              static
            >
              {slider2?.map((logo, idx) => (
                <img
                  key={`logo-${idx}`}
                  src={logo}
                  alt={`Client Logo ${idx + 1}`}
                  className="w-24 h-24 object-contain mx-6"
                  width="96"
                  height="96"
                  loading="lazy"
                />
              ))}
            </Flickity>
          )}
        </div>
      </div>
    </section>
  )
}
